import { useState, useEffect } from 'react';

const useFetchUsers = (
  companyId,
  refreshKey
) => {
  const [allUsers, setAllUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        let endpoint = `/wp-json/ccare/v1/company-users/${companyId}`;
        const response = await fetch(endpoint, {
          headers: {
            'X-WP-Nonce': window.wpData.nonce
          }
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setAllUsers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        jQuery('#loading-spinner-php').hide();
        setIsLoading(false);
      }
    };

    fetchData();
  }, [companyId, refreshKey]);

  return { allUsers, isLoading, error };
};

export default useFetchUsers;
